import { render, staticRenderFns } from "./PlanCreate.vue?vue&type=template&id=5aa53570&"
import script from "./PlanCreate.vue?vue&type=script&lang=js&"
export * from "./PlanCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports